import {OrderAscDesc, Status} from './Enums';

export class FilterQuery {
    FILTER: Filter;
    ORDER: FilterOrder;

    static parse(json: any): FilterQuery {
        if (json) {
            const fq = new FilterQuery();

            if (json.FILTER)
                fq.FILTER = Filter.parse(json.FILTER);

            if (json.ORDER)
                fq.ORDER = FilterOrder.parse(json.ORDER);

            return fq;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FilterQuery> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FilterQuery.parse(j));

        return arr;
    }
}

export class Filter {
    QUERY: string;
    GENERATOR_NAME: Array<string>;
    ORGANIZATION: Array<string>;
    NAICS: Array<number>;
    STATUS: string;

    static parse(json: any): Filter {
        if (json) {
            const fltr = new Filter();

            fltr.QUERY = json.QUERY;
            fltr.GENERATOR_NAME = json.GENERATOR_NAME;
            fltr.ORGANIZATION = json.ORGANIZATION;
            fltr.NAICS = json.NAICS;
            fltr.STATUS = json.STATUS;

            return fltr;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Filter> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Filter.parse(j));

        return arr;
    }
}

export class FilterOrder {
    KEY: string;
    VALUE: any;

    static parse(json: any): FilterOrder {
        if (json) {
            const odr = new FilterOrder();

            odr.KEY = json.KEY;
            odr.VALUE = OrderAscDesc[<string>json.VALUE];

            return odr;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FilterOrder> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FilterOrder.parse(j));

        return arr;
    }
}
